import {
	AUTENTICACAO_LOGAR,
	AUTENTICACAO_SAIR
} from "../actions/actionTypes";


const initialState = {
	userId: '',
	userName: "",
	userEmail: "",
	userToken: "",
	userRole: ""
};
export const authReducer = (state = initialState, action) => {

	switch (action.type) {
		case AUTENTICACAO_LOGAR:
			return {
				...state,
				userId: action.userId,
				userName: action.userName,
				userEmail: action.userEmail,
				userToken: action.userToken,
				userRole: action.userRole
			};
		case AUTENTICACAO_SAIR:
			return initialState;

		default:
			return state;
	}
};
